import React from 'react';
import { Link } from 'react-router-dom';

const ShopHero: React.FC = () => (
  <section className="bg-[#FAF8F5] relative overflow-hidden flex items-center min-h-screen">
    {/* On phone: dark overlay so hero text can be white */}
    <div className="absolute inset-0 bg-primary/95 z-[5] md:bg-transparent md:pointer-events-none" aria-hidden />
    <div className="container-main relative z-20 w-full flex flex-col md:flex-row items-center justify-between h-full pt-16 pb-12 md:py-0">
      {/* Left Text Side */}
      <div className="md:w-[40%] z-20 w-full relative mt-20 md:mt-0">
        <h1 className="text-5xl md:text-6xl font-extrabold text-white md:text-[#1a1a1a] mb-3 drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)] md:drop-shadow-none" style={{ WebkitTextStroke: '0.5px rgba(0,0,0,0.3)' }}>
          <span className="md:[&]:[-webkit-text-stroke:0]">Shop</span>
        </h1>
        <div className="text-xs font-semibold tracking-wide text-white/80 md:text-gray-500 flex items-center gap-2 uppercase drop-shadow-[0_1px_1px_rgba(0,0,0,0.4)] md:drop-shadow-none">
           <Link to="/" className="hover:text-accent md:hover:text-primary transition-colors">Home</Link>
           <span className="text-white/60 md:text-gray-300">›</span>
           <span className="text-white/70 md:text-gray-400">Shop</span>
        </div>
      </div>
      
    </div>

    {/* Right Image Side Background Layer */}
    <div className="absolute right-0 top-0 bottom-0 w-full md:w-[70%] lg:w-[60%] h-full z-10 pointer-events-none">
        <img 
          src="https://images.unsplash.com/photo-1579154204601-01588f351e67?q=80&w=2670&auto=format&fit=crop" 
          alt="Medical Supplies Collection" 
          className="w-full h-full object-cover object-center"
        />
        {/* Subtle fade to blend image smoothly into the background color */}
        <div className="absolute inset-y-0 left-0 w-64 bg-gradient-to-r from-[#FAF8F5] via-[#FAF8F5]/80 to-transparent hidden md:block" />
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-[#FAF8F5] to-transparent md:hidden" />
    </div>
  </section>
);

export default ShopHero;
